import { Link } from 'react-router';
import { Trophy } from 'lucide-react';

/** Wspólne logo Turnivo: puchar w gradientowym boxie + napis Turnivo (jak w navbarze landing page). */
export function TurnivoLogo({
  className = '',
  boxSize = 'h-11 w-11',
  iconSize = 'w-6 h-6',
  textSize = 'text-xl',
  showText = true,
  asLink = true,
  href = '/',
}: {
  className?: string;
  boxSize?: string;
  iconSize?: string;
  textSize?: string;
  showText?: boolean;
  asLink?: boolean;
  href?: string;
}) {
  const content = (
    <>
      <div
        className={`relative rounded-2xl bg-gradient-to-br from-[#0066FF] to-[#00C7B1] text-white grid place-items-center font-bold text-base shadow-lg ${boxSize}`}
      >
        <Trophy className={iconSize} />
      </div>
      {showText && (
        <span
          className={`font-extrabold tracking-tight bg-gradient-to-r from-[#0066FF] to-[#00C7B1] bg-clip-text text-transparent ${textSize}`}
        >
          Turnivo
        </span>
      )}
    </>
  );

  if (asLink) {
    return (
      <Link to={href} className={`flex items-center gap-3 group ${className}`}>
        {content}
      </Link>
    );
  }
  return <div className={`flex items-center gap-3 ${className}`}>{content}</div>;
}
